import { HeatingMediumEnum } from 'src/types/ViewModel/Vessel/HeatingMediumEnum';
import { CoatingTypeEnum } from 'src/enums/stowage/coatingTypeEnum';
import { IbcTankTypeEnum } from 'src/enums/stowage/IbcTankTypeEnum';
import { ImoShipTypeEnum } from 'src/enums/stowage/imoShipTypeEnum';
import { TankSectionEnum } from 'src/types/ViewModel/Vessel/TankPlan';
import { Tank } from 'src/types/ViewModel/Vessel/Tank';

export const isDeckTank = (tank: Tank): boolean => {
    return tank.section === TankSectionEnum.Deck;
};

export const getCoatingName = (coatingType: number): string => {
    switch (coatingType) {
        case 1:
            return 'SS';
        case 2:
            return 'E';
        case 3:
            return 'Z';
        case 4:
            return 'M';
        default:
            return 'N/A';
    }
};

export const getCoatingTypeName = (coatingType: number): string => {
    switch (coatingType) {
        case CoatingTypeEnum.StainlessSteel:
            return 'Stainless Steel';
        case CoatingTypeEnum.Epoxy:
            return 'Epoxy';
        case CoatingTypeEnum.Zink:
            return 'Zink';
        case CoatingTypeEnum.MarineLine:
            return 'MarineLine';
        default:
            return 'Unknown';
    }
};

export const getHasPoCapacity = (hasPoCapacity: boolean): string => {
    if (hasPoCapacity) {
        return 'Yes';
    } else {
        return 'No';
    }
};

export const getHasCooling = (hasCooling: boolean): string => {
    if (hasCooling) {
        return 'Yes';
    } else {
        return 'No';
    }
};

export const getHeatingMedium = (heatingMedium: number): string => {
    switch (heatingMedium) {
        case HeatingMediumEnum.Water:
            return 'Water';
        case HeatingMediumEnum.Steam:
            return 'Steam';
        case HeatingMediumEnum.ThermalOil:
            return 'Thermal oil';
        default:
            return 'None';
    }
};

export const getIbcTankType = (ibcTankType: number): string => {
    switch (ibcTankType) {
        case IbcTankTypeEnum.Type1G:
            return '1G';
        case IbcTankTypeEnum.Type2G:
            return '2G';
        case IbcTankTypeEnum.Type1P:
            return '1P';
        case IbcTankTypeEnum.Type2P:
            return '2P';
        default:
            return 'N/A';
    }
};

export const getImoTankType = (imoTankType: number): string => {
    switch (imoTankType) {
        case ImoShipTypeEnum.One:
            return 'Type 1';
        case ImoShipTypeEnum.Two:
            return 'Type 2';
        case ImoShipTypeEnum.Three:
            return 'Type 3';
        default:
            return 'N/A';
    }
};
